import PnlBreakdownGetter from "reports/getters/pnlBreakdownGetter/PnlBreakdownGetter";
import { PnlBreakdown } from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { isEmpty } from "lodash";
import { useState } from "react";
import useEosData from "reports/store/useEosData";
import { MetricEnum } from "reports/utils/metricTypes";
import EOSReport from "../../../../components/Reports/EOSReport";
import MetricAndPnLBreakdowns from "../../../../components/Reports/GenericCharts/MetricAndPnLBreakdowns/MetricAndPnLBreakdowns";
import PnLChart from "../../../../components/Reports/GenericCharts/PnLChart/PnLChart";
import { getPnlTimes } from "../../../../components/Reports/GenericCharts/PnLChart/pnlChartUtils";
import {
  useGeAndLtFromUrl,
  useProcessGroupNameAndMachemetryIds,
} from "../../../../components/Reports/reportUtils";
import LoadingCircle from "reports/components/simple/LoadingCircle";
import KrugerSummaryMetrics from "./KrugerSummaryMetrics";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function KrugerEOS() {
  const { processGroupName, machemetryIds } =
    useProcessGroupNameAndMachemetryIds({ defaultProcessGroupName: "All" });

  // EOS needs ge and lt url params, sample is December 9, 2020, 8AM - 4PM
  const sampleLink = `/${processGroupName}?ge=1607518800000&lt=1607547600000`;
  const flightGroup = "All";
  const { ge, lt } = useGeAndLtFromUrl();
  const [otherMachineData, setOtherMachineData] = useState<PnlBreakdown>();

  const otherMachemetryIds = machemetryIds.filter(elem => {
    // exclude the constraint process
    return LINE_TO_CONSTRAINT_MAPPING[processGroupName.toLowerCase()] !== elem;
  });

  return (
    <>
      {machemetryIds && machemetryIds.length > 0 ? (
        <>
          <PnlBreakdownGetter
            range={{ ge, lt }}
            setPnlBreakdownData={setOtherMachineData}
            machemetryIds={otherMachemetryIds}
          />
          <EOSReport
            machemetryIds={machemetryIds}
            sampleLink={sampleLink}
            flightTimelineLinkGroup={flightGroup}
            flightDashboardLinkGroup={flightGroup}
            shouldShowPrint={false}
            shouldSkipSkuData={false}
          >
            <KrugerEosComponents
              {...{ processGroupName, machemetryIds, otherMachineData }}
            />
          </EOSReport>
        </>
      ) : (
        <LoadingCircle
          logAfterTimeout={{
            logData: { machemetryIds },
            delay: 5 * 1000,
          }}
        />
      )}
    </>
  );
}

export const LINE_TO_CONSTRAINT_MAPPING = {
  "line 1": "kruger_d_101",
  "line 2": "kruger_d_202",
  "line 3": "kruger_d_301",
  "line 4": "kruger_d_401",
  "line 5": "kruger_d_501",
  "line 7": "kruger_d_001",
  "line 8": "kruger_d_807",
  "line 9": "kruger_d_1209",
  "line 10": "kruger_d_1207",
  "line 11": "kruger_d_1208",
  "line 12": "kruger_d_1201",
};

function KrugerEosComponents({
  processGroupName,
  machemetryIds,
  otherMachineData,
}) {
  const { data, pnlBreakdownsByProcess } = useEosData();
  const reportConfig = useReportConfig();

  const constantConstraintData = pnlBreakdownsByProcess.find(
    pnlData =>
      processGroupName &&
      pnlData.machemetryIds[0] ===
        LINE_TO_CONSTRAINT_MAPPING[processGroupName.toLowerCase()]
  );

  return data &&
    !isEmpty(data) &&
    machemetryIds &&
    machemetryIds.length > 0 &&
    constantConstraintData ? (
    <>
      <KrugerSummaryMetrics
        {...{ data: constantConstraintData, processGroupName }}
      />
      <PnLChart
        customHeader={` (${processGroupName})`}
        pnlTimes={getPnlTimes({
          data: constantConstraintData,
        })}
      />
      {otherMachineData && (
        <PnLChart
          customHeader={" (Other Machines)"}
          pnlTimes={getPnlTimes({
            data: otherMachineData,
          })}
        />
      )}
      <MetricAndPnLBreakdowns
        {...{
          machemetryIds,
        }}
        summaryMetricsInputList={
          reportConfig?.eosReportMetricsConfig?.summaryMetricsInputList ?? [
            { name: MetricEnum.AVAIL },
            { name: MetricEnum.UPTIME },
            { name: MetricEnum.TAGGING },
          ]
        }
      />
    </>
  ) : (
    <LoadingCircle />
  );
}
